import { SectionDef } from './bol';

export const get = (obj: any, path: string) =>
  path.split('.').reduce((o, k) => (o == null ? undefined : o[k]), obj);

export const SECTIONS: SectionDef[] = [
  {
    title: 'Pickup and Delivery',
    fields: [
      { label: 'Warehouse Name', path: 'firstForm.warehouseDetails.warehouse_name' },
      { label: 'Warehouse Address', path: 'firstForm.warehouseDetails.address' },
      { label: 'Warehouse Telephone', path: 'firstForm.warehouseDetails.telephone' },
      { label: 'Warehouse Email', path: 'firstForm.warehouseDetails.email' },
      { label: 'Warehouse Shipping Hours', path: 'firstForm.warehouseDetails.shipping_hours' },
      { label: 'Company Name', path: 'firstForm.deliveryLocation.companyName' },
      { label: 'Company Email', path: 'firstForm.deliveryLocation.email.email' },
      { label: 'Company Address', path: 'firstForm.deliveryLocation.address' }
    ]
  },
  {
    title: 'Identifiers',
    fields: [
      { label: 'Invoice Number', path: 'firstForm.identifiers.invoiceNumber' },
      { label: 'Quote Number', path: 'firstForm.identifiers.quoteNumber' }
    ]
  },
  {
    title: 'Customer Order Information',
    fields: [
      { label: 'Customer PO Number', path: 'customerOrderInformation.customerPoNumber' },
      { label: 'No. of Packages', path: 'customerOrderInformation.totalPackages' },
      {
        label: 'Total Weight (in MT)',
        path: 'customerOrderInformation.totalWeight',
        render: (v, d) => `${v} ${d.customerOrderInformation.unitOfWeight}`
      },
      { label: 'Additional Notes', path: 'firstForm.additionalNotes' }
    ]
  },
  {
    title: 'Carrier Information',
    fields: [
      { label: 'Carrier Name', path: 'secondForm.carrierInfo.name' },
      { label: 'Carrier Quote ID', path: 'secondForm.carrierInfo.quoteId' }
    ]
  },
  {
    title: 'Freight Charges',
    fields: [
      {
        label: 'Prepaid',
        path: 'secondForm.freightCharges.prepaid',
        render: (v, d) => {
          if (!v) return null; // Let sanitizeValue handle it
          const currency = d.secondForm.freightCharges.prepaidCurrency?.value;
          return currency ? `${v} ${currency}` : v;
        }
      },
      {
        label: 'Collect',
        path: 'secondForm.freightCharges.collect',
        render: (v, d) => {
          if (!v) return null; // Let sanitizeValue handle it
          const currency = d.secondForm.freightCharges.collectCurrency?.value;
          return currency ? `${v} ${currency}` : v;
        }
      },
      {
        label: '3rd Party',
        path: 'secondForm.freightCharges.thirdParty',
        render: (v, d) => {
          if (!v) return null; // Let sanitizeValue handle it
          const currency = d.secondForm.freightCharges.thirdPartyCurrency?.value;
          return currency ? `${v} ${currency}` : v;
        }
      }
    ]
  },
  {
    title: 'Instructions',
    fields: [
      { label: 'Emergency Contact', path: 'secondForm.instructions.emergencyContact' },
      { label: 'Origin Instructions', path: 'secondForm.instructions.originInstructions' },
      {
        label: 'Destination Instructions',
        path: 'secondForm.instructions.destinationInstructions'
      },
      { label: 'Origin Accessorials', path: 'secondForm.instructions.originAccessorials' },
      {
        label: 'Destination Accessorials',
        path: 'secondForm.instructions.destinationAccessorials'
      },
      { label: 'Special Instructions', path: 'secondForm.instructions.special' }
    ]
  }
];
